<!-- .modal--show starts 'show' animation -->
<!-- .modal--hide starts 'hides' animation-->

<div>
	<div class="modal"
	     [ngClass]="{'modal--show': popupOpen, 'modal--hide': !popupOpen}">
		<div class="modal-background"></div>

		<div class="modal-container" id="modal-start-order">
			<h1 class="modal-title" i18n="Start new order link text@@start.new.order.link.text">Start a new order</h1>

			<!-- This state should never happen, but better safe than sorry-->
			@if (!shipmentDates || shipmentDates.length < 1) {
			<div>
				There are no available delivery dates found for this product.
				Please try again or contact us if the problem continues to occur.
				<div class="button-bar button-bar--right button-bar--mobile-block">
					<button type="button" class="button" (click)="close()"
					        i18n="Modal dialog: button: close@@close.button">
						Close
					</button>
				</div>
			</div>
			}

			@if (shipmentDates && shipmentDates.length > 0) {
			<div>
				<p class="modal-intro" i18n="Modal dialog: add/start new intro@@add.or.start.order">
					Add your product to an existing order or start a new one.
				</p>
				<div class="modal-form">
					<form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
						<div class="form-row">
							@if (getDeliveryDateForOrders() && getDeliveryDateForOrders().length > 0 &&
							applicationService.showPopupExistingOrders) {
							<label (click)="startNew = false"
							>
								<input type="radio" name="order-destination" value="existing-order"
								       checked="{{startNew ? '' : 'checked'}}">
								<span class="checkbox-icon"></span>
								<ng-container i18n="Modal dialog: add to existing@@add.to.existing">
									Add to existing order
								</ng-container>
							</label>
							}
						</div>
						@if (!startNew) {
						<div class="form-row">
							<label class="form-label" for="activeOrder" i18n="@@shipping.date">Shipping date</label>
							<div class="form-input-container">
								<div class="custom-select">
									<select name="activeOrder" id="activeOrder"
									        [formControl]="form.controls['selectedOrder']">
										@for (deliveryDate of getDeliveryDateForOrders(); track deliveryDate) {
										<option
												[ngValue]="getActiveOrderForDeliveryDate(deliveryDate)">
                            <span render-day-of-week
                                  [day]="deliveryDate.shippingDayName"></span>
											{{ deliveryDate.shipmentDate | customDate:'dd-MM' }}
											<span>
                              <span i18n="Delivery label in start new order popup@@start.new.order.popup.delivery">(Delivery:</span>
                              <span render-day-of-week-abbr [day]="deliveryDate.deliveryDayName"></span>
	                            {{ deliveryDate.deliveryDate | customDate:'dd-MM' }}
                              <span render-part-of-day
                                    [partOfDay]="deliveryDate.dagDeelAankomst"></span>)
                            </span>
										</option>
										}
									</select>
								</div>
								@if (selectedOrderSelect) {
								<p data-private>
									{{ selectedOrderSelect.deliveryAddressName }}
									({{ selectedOrderSelect.shipToCode }})<br />
									{{ selectedOrderSelect.volume | numberFormat:false }} CC <!-- Translatable?? -->
								</p>
								}
							</div>
						</div>
						}
						<div class="form-row">
							<label (click)="startNew = true">
								<input type="radio" name="order-destination" value="new-order"
								       checked="{{startNew ? 'checked' : ''}}">
								<span class="checkbox-icon"></span>
								<ng-container i18n="Modal dialog: start new order@@start.new.order.button">
									Start a new order
								</ng-container>
							</label>
						</div>
						@if (startNew && loaded) {
						<div class="form-row">
							<label class="form-label" for="shipmentDate" i18n="@@shipping.date">Shipping date</label>
							<div class="form-input-container">
								<div class="custom-select">
									<select name="shipmentDate" id="shipmentDate"
									        [formControl]="form.controls['shipmentDate']"
									        (change)="changeDate()">
										@for (shipping of shipmentDates; track shipping) {
										<option [ngValue]="shipping">
											<!--                            <span render-day-of-week [day]="shipping.shippingDayName"></span>-->
											{{ shipping.shipmentDate | customDate:'dd-MM' }}
											<span>
                              <span i18n="Delivery label in start new order popup@@start.new.order.popup.delivery">(Delivery:</span>
												<!--                              <span render-day-of-week-abbr-->
												<!--                              [day]="shipping.deliveryDayName"></span>-->
                              {{ shipping.deliveryDate | customDate:'dd-MM' }}
                              <span render-part-of-day
                                    [partOfDay]="shipping.dagDeelAankomst"></span>)
                            </span>
										</option>
										}
									</select>
								</div>
							</div>
						</div>
						<div class="form-row modal-start-order__addresses">
							<label class="form-label" i18n="@@delivery.address">Delivery address</label>
							<div class="form-input-container">
								@for (address of deliveryAddresses; track address; let i = $index) {
								<div class="delivery-address-option"
								>
									<input type="radio" name="deliveryAddress" id="deliveryAddress_{{i}}"
									       [value]="address"
									       [formControl]="form.controls['deliveryAddress']"
									       (click)="deliveryAddress = address" [checked]="i === 0" />
									<label htmlFor="deliveryAddress_{{i}}">
										<span class="checkbox-icon"></span>
										<div class="address">
											<h3 data-private>{{ address.name }} ({{ address.code }})</h3>
											<p data-private>
												{{ address.address }}<br />
												{{ address.postcode }} {{ address.city }}<br />
												{{ address.country }}
											</p>
										</div>
									</label>
								</div>
								}
							</div>
						</div>
						}
						<div class="button-bar button-bar--right button-bar--mobile-block">
							<button type="button" class="button theme-btn-primary" (click)="close()"
							        i18n="Modal dialog: button: close@@close.button">
								Close
							</button>
							@if (startNew) {
							<button type="submit" class="button button--green theme-btn-success"
							        i18n="Modal dialog: button: start new order@@start.new.order.button">
								Start new order
							</button>
							}
							@if (!startNew) {
							<button type="submit" class="button button--green theme-btn-success"
							        i18n="Modal dialog: button: add and continue@@add.continue.order.button">
								Add and continue order
							</button>
							}
						</div>
					</form>
				</div>
			</div>
			}
		</div>
	</div>
</div>
